import { Button, ButtonGroup, buttonName, useItemNames } from '@ps-smart-cp/ppfw-client';

// TODO: カスタムマスタ取込・出力対応時に削除 (https://proship-infra.atlassian.net/browse/AFW-306)
interface CustomMstMaintenanceFooterButtonTempProps {
  onSearch: () => void;
  onReset: () => void;
}

export function CustomMstMaintenanceFooterButtonTemp({
  onSearch,
  onReset,
}: CustomMstMaintenanceFooterButtonTempProps) {
  const getButtonName = useItemNames(buttonName);
  return (
    <ButtonGroup alignment="right">
      <Button label={getButtonName('inquiry')} onClick={onSearch} />
      <Button label={getButtonName('reset')} onClick={onReset} />
    </ButtonGroup>
  );
}
